import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { NumItemsBeingReturnedOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  itemsBeingReturnedCountFromModel,
  validateItemsBeingReturnedCountCondition,
  type ItemsBeingReturnedCountState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ITEMS_BEING_RETURNED_COUNT = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ItemsBeingReturnedCountState>
  >,
): ConditionType<
  ItemsBeingReturnedCountState,
  Condition.ItemsBeingReturnedCount
> => ({
  name: CONDITION_NAMES[Condition.ITEMS_BEING_RETURNED_COUNT],
  description(state) {
    switch (state.numItemsOption) {
      case NumItemsBeingReturnedOption.LESS_THAN:
        return t("Number of items less than {{value}}", {
          value: state.numItems,
        });
      case NumItemsBeingReturnedOption.GREATER_THAN:
        return t("Number of items greater than {{value}}", {
          value: state.numItems,
        });
      case NumItemsBeingReturnedOption.EQUALS:
        return t("Number of items equals {{value}}", { value: state.numItems });
    }
  },
  Details(props: ConditionTypeDetailsProps<ItemsBeingReturnedCountState>) {
    return React.createElement(Details, props);
  },
  empty: { numItemsOption: NumItemsBeingReturnedOption.EQUALS, numItems: "1" },
  fromModel(model) {
    return itemsBeingReturnedCountFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.ITEMS_BEING_RETURNED_COUNT,
      numItemsOption: state.numItemsOption,
      numItems: +state.numItems,
    };
  },
  valid(state) {
    return validateItemsBeingReturnedCountCondition(state).valid;
  },
});
